import type { IconData } from '@stacksjs/iconify-core'

export const chatBubbleOvalNotification: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path stroke-linecap=\"round\" d=\"M24 3C12.402 3 3 12.402 3 24c0 3.802 1.01 7.367 2.777 10.443c-.91 2.377-1.768 5.137-2.331 7.896a1.797 1.797 0 0 0 2.197 2.12c2.643-.626 5.325-1.494 7.681-2.371A20.9 20.9 0 0 0 24 45c11.598 0 21-9.402 21-21q0-.503-.023-1\"/><path d=\"M45 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default chatBubbleOvalNotification
